<div class="card main-store-card container-fluid">
  
  <!-- Header: Titulo y Botón Volver -->
  <div class="row justify-content-between align-items-center mb-4">
    <div class="col-auto">
      <h3 class="m-0 font-bold text-muted">{{ titulo }}</h3>
    </div>
    <div class="col-auto">
      <p-button
        label="Volver"
        icon="pi pi-arrow-left"
        routerLink="/admin/store"
        severity="secondary"
        [rounded]="true"
        size="small"
      />
    </div>
  </div>

  <!-- Banner Principal Dinámico -->
  <div class="store-banner"></div>

  <!-- Perfil Superpuesto Dinámico -->
  <div class="store-profile-header">
    <div class="logo-container">
      @if (logoPreview) {
        <img [src]="logoPreview" alt="Logo" class="store-logo-img" />
      } @else {
        <div class="store-logo-placeholder">
          {{ (formStore.get('sto_name')?.value || 'NT').slice(0, 2) }}
        </div>
      }
    </div>
    
    <div class="store-meta-info">
      <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
        <h2 class="store-title m-0">{{ formStore.get('sto_name')?.value || 'Nuevo Negocio' }}</h2>
        <span class="status-badge status-open">
          Creación en Progreso
        </span>
      </div>
      <p class="store-description m-0">{{ formStore.get('sto_description')?.value || 'Configure la información básica de su negocio para comenzar.' }}</p>
    </div>
  </div>

  <!-- Stepper de Creación -->
  <div class="container-fluid p-0 mt-4">
    <p-stepper [(activeStep)]="active" [linear]="true">
      
      <!-- Paso 1: Información Básica -->
      <p-stepperPanel header="{{ step1_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-center mt-3">
            <div class="w-full" style="max-width: 800px;">
              <div class="detail-card">
                <div class="detail-card-title">
                  <i class="pi pi-info-circle"></i> Información Básica
                </div>
                
                <form (ngSubmit)="next()" [formGroup]="formStore" class="mt-3">
                  <div class="row">
                    <!-- Nombre de la tienda -->
                    <div class="col-md-6 mb-3">
                      <label for="sto_name" class="form-label-edit d-block mb-2">Nombre del Negocio *</label>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <i class="pi pi-shop"></i>
                        </span>
                        <input
                          id="sto_name"
                          type="text"
                          pInputText
                          formControlName="sto_name"
                          placeholder="Nombre comercial"
                          class="largeInput"
                          [ngClass]="{
                            'field-length-invalid': formStore.controls['sto_name'].hasError('maxlength'),
                          }"
                        />
                      </div>
                      <div
                        id="sto-name-counter"
                        class="field-length-counter"
                        [class.field-length-counter-exceeded]="formStore.controls['sto_name'].hasError('maxlength')"
                      >
                        {{ formStore.controls['sto_name'].value?.length ?? 0 }} / 50 caracteres
                      </div>
                      @if (
                        formStore.controls['sto_name'].hasError('required') &&
                        formStore.controls['sto_name'].touched
                      ) {
                        <span class="text-danger labelError">
                          <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                        </span>
                      }
                    </div>

                    <!-- Teléfono de la tienda -->
                    <div class="col-md-6 mb-3">
                      <label for="sto_phone" class="form-label-edit d-block mb-2">Teléfono de Contacto *</label>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <i class="pi pi-phone"></i>
                        </span>
                        <input
                          id="sto_phone"
                          type="text"
                          pInputText
                          formControlName="sto_phone"
                          placeholder="Teléfono de contacto"
                          class="largeInput"
                          [ngClass]="{
                            'field-length-invalid': formStore.controls['sto_phone'].hasError('maxlength'),
                          }"
                        />
                      </div>
                      <div
                        id="sto-phone-counter"
                        class="field-length-counter"
                        [class.field-length-counter-exceeded]="formStore.controls['sto_phone'].hasError('maxlength')"
                      >
                        {{ formStore.controls['sto_phone'].value?.length ?? 0 }} / 20 caracteres
                      </div>
                      @if (
                        formStore.controls['sto_phone'].hasError('required') &&
                        formStore.controls['sto_phone'].touched
                      ) {
                        <span class="text-danger labelError">
                          <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                        </span>
                      }
                    </div>
                  </div>

                  <!-- Descripción comercial -->
                  <div class="row mb-3">
                    <div class="col-12">
                      <label for="sto_description" class="form-label-edit d-block mb-2">Descripción Comercial</label>
                      <textarea
                        id="sto_description"
                        pInputTextarea
                        formControlName="sto_description"
                        rows="3"
                        placeholder="Breve descripción del negocio..."
                        class="largeInput"
                        [ngClass]="{
                          'field-length-invalid': formStore.controls['sto_description'].hasError('maxlength'),
                        }"
                      ></textarea>
                      <div
                        id="sto-description-counter"
                        class="field-length-counter"
                        [class.field-length-counter-exceeded]="formStore.controls['sto_description'].hasError('maxlength')"
                      >
                        {{ formStore.controls['sto_description'].value?.length ?? 0 }} / 500 caracteres
                      </div>
                    </div>
                  </div>

                  <!-- Negocio Destacado -->
                  <div class="row mb-3">
                    <div class="col-12">
                      <label for="sto_is_featured" class="form-label-edit d-block mb-2">Negocio Destacado</label>
                      <p-toggleButton
                        id="sto_is_featured"
                        formControlName="sto_is_featured"
                        onLabel="Sí"
                        offLabel="No"
                      />
                    </div>
                  </div>

                  <div class="d-flex pt-3 justify-content-end border-top">
                    <p-button
                      label="Siguiente"
                      icon="pi pi-arrow-right"
                      iconPos="right"
                      type="submit"
                      [rounded]="true"
                      [disabled]="formStore.invalid"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- Paso 2: Horarios -->
      <p-stepperPanel header="{{ step2_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-center mt-3">
            <div class="w-full" style="max-width: 900px;">
              <div class="detail-card">
                <div class="detail-card-title mb-3">
                  <i class="pi pi-clock"></i> Horarios de Recepción de Pedidos *
                </div>
                
                <p-table [value]="ltsSchedules" styleClass="p-datatable-sm p-datatable-striped mb-4">
                  <ng-template pTemplate="header">
                    <tr>
                      <th id="tbday" style="width: 25%">Día</th>
                      <th id="tbopen" style="width: 25%">Abierto</th>
                      <th id="tbopentime" style="width: 25%">Hora Apertura</th>
                      <th id="tbclosetime" style="width: 25%">Hora Cierre</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-schedule>
                    <tr>
                      <td class="font-bold">{{ getDayName(schedule.ssh_day_of_week) }}</td>
                      <td>
                        <p-toggleButton
                          [(ngModel)]="schedule.ssh_is_open"
                          onLabel="Sí"
                          offLabel="No"
                          [style]="{ width: '100%', 'max-width': '120px' }"
                        />
                      </td>
                      <td>
                        <div class="p-inputgroup" [ngClass]="{'opacity-50': !schedule.ssh_is_open}">
                          <span class="p-inputgroup-addon">
                            <i class="pi pi-clock"></i>
                          </span>
                          <p-calendar
                            [(ngModel)]="schedule.ssh_open_time"
                            [timeOnly]="true"
                            hourFormat="24"
                            [disabled]="!schedule.ssh_is_open"
                            styleClass="w-100"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="p-inputgroup" [ngClass]="{'opacity-50': !schedule.ssh_is_open}">
                          <span class="p-inputgroup-addon">
                            <i class="pi pi-clock"></i>
                          </span>
                          <p-calendar
                            [(ngModel)]="schedule.ssh_close_time"
                            [timeOnly]="true"
                            hourFormat="24"
                            [disabled]="!schedule.ssh_is_open"
                            styleClass="w-100"
                          />
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>

                @if (schedulesAttempted && !hasActiveSchedule) {
                  <span class="text-danger labelError d-block mb-3">
                    <i class="pi pi-exclamation-triangle mr-1"></i> Debe habilitar al menos un día de recepción de pedidos
                  </span>
                }

                <div class="d-flex justify-content-between pt-3 border-top">
                  <p-button label="Atrás" icon="pi pi-arrow-left" severity="secondary" [rounded]="true" (onClick)="back()" />
                  <p-button
                    label="Siguiente"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    [rounded]="true"
                    (onClick)="next()"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- Paso 3: Ubicación y Datos Comerciales -->
      <p-stepperPanel header="{{ step3_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-center mt-3">
            <div class="w-full" style="max-width: 1100px;">
              <div class="detail-card">
                <div class="detail-card-title mb-3">
                  <i class="pi pi-map-marker"></i> Ubicación y Parámetros Comerciales
                </div>
                
                <div class="row g-4 mt-1">
                  <!-- Columna izquierda: Formulario -->
                  <div class="col-xl-5">
                    <form [formGroup]="formLocation">
                      
                      <!-- Dirección de la tienda -->
                      <div class="mb-3">
                        <label for="storeAddressInput" class="form-label-edit d-block mb-2">Dirección del Negocio *</label>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">
                            <i class="pi pi-compass"></i>
                          </span>
                          <input
                            id="storeAddressInput"
                            type="text"
                            pInputText
                            formControlName="sto_address"
                            placeholder="Buscar dirección..."
                            autocomplete="off"
                            class="largeInput"
                          />
                        </div>
                        @if (
                          formLocation.controls['sto_address'].hasError('required') &&
                          formLocation.controls['sto_address'].touched
                        ) {
                          <span class="text-danger labelError">
                            <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                          </span>
                        }
                      </div>

                      <!-- División Política / Estado -->
                      <div class="mb-3">
                        <label for="sto_political_division_id" class="form-label-edit d-block mb-2">División Política *</label>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">
                            <i class="pi pi-map-legend"></i>
                          </span>
                          <p-dropdown
                            id="sto_political_division_id"
                            [options]="ltsPolDivisions"
                            formControlName="sto_political_division_id"
                            optionLabel="pd_name"
                            optionValue="pd_code"
                            placeholder="Selecciona un Estado"
                            styleClass="w-100"
                            class="largeInput"
                          />
                        </div>
                        @if (
                          formLocation.controls['sto_political_division_id'].hasError('required') &&
                          formLocation.controls['sto_political_division_id'].touched
                        ) {
                          <span class="text-danger labelError">
                            <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                          </span>
                        }
                      </div>

                      <!-- Radio de Entrega -->
                      <div class="mb-3">
                        <label for="sto_delivery_radius_km" class="form-label-edit d-block mb-2">Radio de Entrega (km) *</label>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">
                            <i class="pi pi-map"></i>
                          </span>
                          <p-inputNumber
                            id="sto_delivery_radius_km"
                            formControlName="sto_delivery_radius_km"
                            mode="decimal"
                            [min]="0"
                            placeholder="Radio en kilómetros"
                            class="largeInput"
                            styleClass="w-100"
                          />
                        </div>
                      </div>

                      <!-- Pedido Mínimo -->
                      <div class="mb-3">
                        <label for="sto_min_order_amount" class="form-label-edit d-block mb-2">Monto de Pedido Mínimo ($) *</label>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">
                            <i class="pi pi-shopping-bag"></i>
                          </span>
                          <input
                            id="sto_min_order_amount"
                            type="text"
                            inputmode="numeric"
                            pInputText
                            appCentsCurrencyInput
                            formControlName="sto_min_order_amount"
                            placeholder="0,00"
                            class="largeInput"
                          />
                        </div>
                      </div>

                      <!-- Tarifa de Envío -->
                      <div class="mb-4">
                        <label for="sto_delivery_fee" class="form-label-edit d-block mb-2">Tarifa de Envío ($) *</label>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">
                            <i class="pi pi-money-bill"></i>
                          </span>
                          <input
                            id="sto_delivery_fee"
                            type="text"
                            inputmode="numeric"
                            pInputText
                            appCentsCurrencyInput
                            formControlName="sto_delivery_fee"
                            placeholder="0,00"
                            class="largeInput"
                          />
                        </div>
                      </div>

                    </form>
                  </div>

                  <!-- Columna derecha: Mapa -->
                  <div class="col-xl-7">
                    <label class="form-label-edit d-block mb-2">Ubicación Geográfica (Haga clic en el mapa o arrastre el marcador) *</label>
                    <div class="map-container">
                      <google-map
                        [center]="mapCenter"
                        [zoom]="mapZoom"
                        [options]="mapOptions"
                        height="100%"
                        width="100%"
                        (mapClick)="onMapClick($event)"
                      />
                    </div>
                    @if (
                      formLocation.controls['sto_lat'].hasError('required') &&
                      formLocation.controls['sto_lat'].touched
                    ) {
                      <span class="text-danger labelError">
                        <i class="pi pi-exclamation-triangle mr-1"></i> Debe seleccionar un punto en el mapa
                      </span>
                    }
                  </div>
                </div>

                <div class="d-flex justify-content-between pt-3 border-top mt-3">
                  <p-button label="Atrás" icon="pi pi-arrow-left" severity="secondary" [rounded]="true" (onClick)="back()" />
                  <p-button
                    label="Siguiente"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    [rounded]="true"
                    [disabled]="formLocation.invalid"
                    (onClick)="next()"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- Paso 4: Logo -->
      <p-stepperPanel header="{{ step4_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-center mt-3">
            <div class="w-full" style="max-width: 600px;">
              <div class="detail-card">
                <div class="detail-card-title mb-3">
                  <i class="pi pi-image"></i> Cargar Logo Comercial
                </div>
                
                <div class="logo-upload-box p-4 text-center mb-4">
                  <i class="pi pi-cloud-upload text-muted mb-3" style="font-size: 3rem;"></i>
                  <p class="text-muted small mb-3">
                    El logo es obligatorio para crear el negocio.
                  </p>

                  <div class="d-flex justify-content-center mb-3">
                    <p-fileUpload
                      #fileUpload
                      mode="basic"
                      chooseLabel="Seleccionar Imagen"
                      chooseIcon="pi pi-upload"
                      [showUploadButton]="false"
                      [showCancelButton]="false"
                      maxFileSize="5000000"
                      (onSelect)="onUploadLogo($event.files, fileUpload)"
                      accept="image/*"
                      [multiple]="false"
                      styleClass="p-button-outlined"
                    />
                  </div>

                  @if (logoAttempted && !logoPreview) {
                    <span class="text-danger labelError d-block mb-3">
                      <i class="pi pi-exclamation-triangle mr-1"></i> Debe cargar un logo para el negocio
                    </span>
                  }

                  @if (logoPreview) {
                    <div class="mt-4 p-3 border rounded bg-light d-flex flex-column align-items-center gap-2">
                      <span class="info-label font-bold">Previsualización</span>
                      <p-image [src]="logoPreview" alt="Logo" width="120" styleClass="shadow-sm rounded border bg-white" />
                      <p-button
                        label="Eliminar Imagen"
                        icon="pi pi-trash"
                        severity="danger"
                        [rounded]="true"
                        size="small"
                        (onClick)="removeFile()"
                        class="mt-2"
                      />
                    </div>
                  }
                </div>

                <div class="d-flex justify-content-between pt-3 border-top">
                  <p-button label="Atrás" icon="pi pi-arrow-left" severity="secondary" [rounded]="true" (onClick)="back()" />
                  <p-button
                    label="Siguiente"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    [rounded]="true"
                    (onClick)="next()"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- Paso 5: Usuario Gestor -->
      <p-stepperPanel header="{{ step5_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-center mt-3">
            <div class="w-full" style="max-width: 800px;">
              <div class="detail-card">
                <div class="detail-card-title">
                  <i class="pi pi-user"></i> Usuario Gestor del Negocio
                </div>
                <p class="text-muted small mt-2 mb-0">
                  Es la persona que administrará el negocio desde el panel. Comuníquele usted el usuario y la
                  contraseña: el sistema no los envía.
                </p>

                <form (ngSubmit)="next()" [formGroup]="formManager" class="mt-3">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label for="adm_name" class="form-label-edit d-block mb-2">Nombre *</label>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
                        <input id="adm_name" type="text" pInputText formControlName="adm_name" placeholder="Nombre" class="largeInput" />
                      </div>
                      @if (formManager.controls.adm_name.invalid && formManager.controls.adm_name.touched) {
                        <span class="text-danger labelError">
                          <i class="pi pi-exclamation-triangle mr-1"></i>
                          {{ formManager.controls.adm_name.hasError('maxlength') ? 'Máximo 50 caracteres' : 'Campo Requerido' }}
                        </span>
                      }
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="adm_last_name" class="form-label-edit d-block mb-2">Apellido *</label>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
                        <input id="adm_last_name" type="text" pInputText formControlName="adm_last_name" placeholder="Apellido" class="largeInput" />
                      </div>
                      @if (formManager.controls.adm_last_name.invalid && formManager.controls.adm_last_name.touched) {
                        <span class="text-danger labelError">
                          <i class="pi pi-exclamation-triangle mr-1"></i>
                          {{ formManager.controls.adm_last_name.hasError('maxlength') ? 'Máximo 50 caracteres' : 'Campo Requerido' }}
                        </span>
                      }
                    </div>

                    <div class="col-md-12 mb-3">
                      <label for="adm_user" class="form-label-edit d-block mb-2">Usuario *</label>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-id-card"></i></span>
                        <input
                          id="adm_user"
                          type="text"
                          pInputText
                          formControlName="adm_user"
                          placeholder="Usuario de inicio de sesión"
                          autocomplete="off"
                          class="largeInput"
                        />
                      </div>
                      <small id="adm-user-hint" class="field-hint">
                        Sin espacios. Es el usuario con el que el gestor iniciará sesión.
                      </small>
                      @if (formManager.controls.adm_user.invalid && formManager.controls.adm_user.touched) {
                        <span class="text-danger labelError d-block">
                          <i class="pi pi-exclamation-triangle mr-1"></i>
                          @if (formManager.controls.adm_user.hasError('taken')) {
                            Este usuario ya existe, elija otro
                          } @else if (formManager.controls.adm_user.hasError('pattern')) {
                            El usuario no puede tener espacios
                          } @else if (formManager.controls.adm_user.hasError('maxlength')) {
                            Máximo 50 caracteres
                          } @else {
                            Campo Requerido
                          }
                        </span>
                      }
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="adm_password" class="form-label-edit d-block mb-2">Contraseña *</label>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
                        <input
                          id="adm_password"
                          [type]="showPassword ? 'text' : 'password'"
                          pInputText
                          formControlName="adm_password"
                          placeholder="Contraseña"
                          autocomplete="new-password"
                          class="largeInput"
                        />
                        <button
                          type="button"
                          class="p-inputgroup-addon password-toggle"
                          [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                          (click)="showPassword = !showPassword"
                        >
                          <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
                        </button>
                      </div>
                      <small id="adm-password-hint" class="field-hint">
                        Mínimo {{ passwordMinLength }} caracteres. Puede usar letras, números y símbolos; distingue
                        mayúsculas de minúsculas.
                      </small>
                      @if (formManager.controls.adm_password.invalid && formManager.controls.adm_password.touched) {
                        <span class="text-danger labelError d-block">
                          <i class="pi pi-exclamation-triangle mr-1"></i>
                          {{
                            formManager.controls.adm_password.hasError('minlength')
                              ? 'Debe tener al menos ' + passwordMinLength + ' caracteres'
                              : 'Campo Requerido'
                          }}
                        </span>
                      }
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="adm_password_confirm" class="form-label-edit d-block mb-2">Confirmar Contraseña *</label>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
                        <input
                          id="adm_password_confirm"
                          [type]="showPasswordConfirm ? 'text' : 'password'"
                          pInputText
                          formControlName="adm_password_confirm"
                          placeholder="Repita la contraseña"
                          autocomplete="new-password"
                          class="largeInput"
                        />
                        <button
                          type="button"
                          class="p-inputgroup-addon password-toggle"
                          [attr.aria-label]="showPasswordConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                          (click)="showPasswordConfirm = !showPasswordConfirm"
                        >
                          <i class="pi" [ngClass]="showPasswordConfirm ? 'pi-eye-slash' : 'pi-eye'"></i>
                        </button>
                      </div>
                      @if (
                        formManager.controls.adm_password_confirm.touched &&
                        (formManager.controls.adm_password_confirm.hasError('required') || formManager.hasError('mismatch'))
                      ) {
                        <span class="text-danger labelError d-block">
                          <i class="pi pi-exclamation-triangle mr-1"></i>
                          {{ formManager.hasError('mismatch') ? 'Las contraseñas no coinciden' : 'Campo Requerido' }}
                        </span>
                      }
                    </div>
                  </div>

                  <div class="d-flex justify-content-between pt-3 border-top">
                    <p-button label="Atrás" icon="pi pi-arrow-left" severity="secondary" [rounded]="true" (onClick)="back()" />
                    <p-button label="Siguiente" icon="pi pi-arrow-right" iconPos="right" [rounded]="true" type="submit" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- Paso 6: Resumen -->
      <p-stepperPanel header="{{ step6_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-center mt-3">
            <div class="w-full" style="max-width: 900px;">
              <div class="detail-card">
                <div class="detail-card-title mb-4">
                  <i class="pi pi-check-circle"></i> Resumen del Nuevo Negocio
                </div>

                <div class="row g-4 mb-4">
                  <!-- Columna Izquierda: Datos Básicos y Ubicación -->
                  <div class="col-md-6">
                    <div class="summary-container h-100">
                      <div class="summary-section-title">
                        <i class="pi pi-info-circle mr-1"></i> Información General
                      </div>
                      
                      <div class="row mb-3">
                        <div class="col-sm-5 summary-label">Nombre:</div>
                        <div class="col-sm-7 summary-value font-bold">{{ formStore.get('sto_name')?.value }}</div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-sm-5 summary-label">Teléfono:</div>
                        <div class="col-sm-7 summary-value">{{ formStore.get('sto_phone')?.value }}</div>
                      </div>

                      <div class="row mb-3" *ngIf="formStore.get('sto_description')?.value">
                        <div class="col-sm-5 summary-label">Descripción:</div>
                        <div class="col-sm-7 summary-value text-muted">{{ formStore.get('sto_description')?.value }}</div>
                      </div>

                      <div class="summary-section-title mt-4">
                        <i class="pi pi-map-marker mr-1"></i> Ubicación
                      </div>

                      <div class="row mb-2">
                        <div class="col-sm-5 summary-label">Dirección:</div>
                        <div class="col-sm-7 summary-value font-bold">{{ formLocation.get('sto_address')?.value }}</div>
                      </div>

                      <div class="row mb-2">
                        <div class="col-sm-5 summary-label">División:</div>
                        <div class="col-sm-7 summary-value">{{ getPolDivisionName() }}</div>
                      </div>

                      <div class="row mb-2">
                        <div class="col-sm-5 summary-label">Coordenadas:</div>
                        <div class="col-sm-7 summary-value text-muted small">
                          {{ formLocation.get('sto_lat')?.value | number: '1.4-4' }}, 
                          {{ formLocation.get('sto_lng')?.value | number: '1.4-4' }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Columna Derecha: Parámetros y Horarios -->
                  <div class="col-md-6">
                    <div class="summary-container h-100">
                      <div class="summary-section-title">
                        <i class="pi pi-shopping-bag mr-1"></i> Parámetros Comerciales
                      </div>

                      <div class="row mb-3">
                        <div class="col-sm-6 summary-label">Radio de Entrega:</div>
                        <div class="col-sm-6 summary-value">{{ formLocation.get('sto_delivery_radius_km')?.value }} km</div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-sm-6 summary-label">Pedido Mínimo:</div>
                        <div class="col-sm-6 summary-value">${{ formLocation.get('sto_min_order_amount')?.value | number: '1.2-2' }}</div>
                      </div>

                      <div class="row mb-4">
                        <div class="col-sm-6 summary-label">Tarifa de Entrega:</div>
                        <div class="col-sm-6 summary-value">${{ formLocation.get('sto_delivery_fee')?.value | number: '1.2-2' }}</div>
                      </div>

                      @if (logoPreview) {
                        <div class="summary-section-title mt-2">
                          <i class="pi pi-image mr-1"></i> Logotipo
                        </div>
                        <div class="text-center bg-white p-2 border rounded" style="max-width: 140px;">
                          <p-image [src]="logoPreview" alt="Logo" width="100" styleClass="rounded" />
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- Usuario Gestor (sin contraseña) -->
                <div class="summary-container mb-4">
                  <div class="summary-section-title">
                    <i class="pi pi-user mr-1"></i> Usuario Gestor
                  </div>
                  <div class="row mb-2">
                    <div class="col-sm-3 summary-label">Nombre:</div>
                    <div class="col-sm-9 summary-value font-bold">
                      {{ formManager.controls.adm_name.value }} {{ formManager.controls.adm_last_name.value }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-3 summary-label">Usuario:</div>
                    <div class="col-sm-9 summary-value">{{ formManager.controls.adm_user.value }}</div>
                  </div>
                </div>

                <!-- Horarios Activos -->
                <div class="summary-container mb-4">
                  <div class="summary-section-title">
                    <i class="pi pi-clock mr-1"></i> Horarios de Recepción de Pedidos
                  </div>
                  <div *ngIf="getActiveSchedules().length > 0; else noSchedules">
                    <div class="row g-2">
                      <div class="col-md-4 col-sm-6" *ngFor="let schedule of getActiveSchedules()">
                        <div class="p-2 border rounded bg-white d-flex justify-content-between align-items-center">
                          <span class="font-bold small">{{ getDayName(schedule.ssh_day_of_week) }}</span>
                          <span class="badge bg-primary-subtle text-primary small">
                            {{ schedule.ssh_open_time }} - {{ schedule.ssh_close_time }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #noSchedules>
                    <div class="text-center py-3 bg-white border rounded text-muted">
                      <i class="pi pi-calendar-times mr-2"></i> No se han configurado horarios de recepción de pedidos (Cerrado todos los días)
                    </div>
                  </ng-template>
                </div>

                <!-- Botones de navegación y acción final -->
                <div class="d-flex justify-content-between pt-3 border-top mt-3">
                  <p-button label="Atrás" icon="pi pi-arrow-left" severity="secondary" [rounded]="true" (onClick)="back()" />
                  <p-button
                    label="Guardar Negocio"
                    icon="pi pi-save"
                    severity="success"
                    [rounded]="true"
                    (onClick)="showConfirmation()"
                    [loading]="loading"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

    </p-stepper>
  </div>
</div>

<!-- Modal de confirmación -->
<p-dialog
  [(visible)]="showConfirmDialog"
  header="Confirmar Creación de Negocio"
  [modal]="true"
  [style]="{ width: '450px' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
>
  <div class="text-center py-3">
    <i class="pi pi-question-circle text-primary mb-3" style="font-size: 3rem;"></i>
    <p class="m-0 font-medium">¿Está seguro de que desea crear el negocio con los datos ingresados?</p>
  </div>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-center gap-2">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        [rounded]="true"
        (onClick)="showConfirmDialog = false"
        styleClass="p-button-text p-button-secondary"
      />
      <p-button
        label="Confirmar"
        icon="pi pi-check"
        [rounded]="true"
        (onClick)="confirmAndCreate()"
        severity="success"
        [loading]="loading"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Credenciales del gestor: se cierra solo con el botón para no perderlas por un clic afuera -->
<p-dialog
  [(visible)]="showCredentialsDialog"
  header="Negocio creado"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [style]="{ width: '450px' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
>
  @if (createdCredentials) {
    <div class="py-2">
      <p class="mb-3">
        Comunique estos datos al gestor del negocio. La contraseña no se volverá a mostrar.
      </p>
      <div class="summary-container">
        <div class="row mb-2">
          <div class="col-4 summary-label">Usuario:</div>
          <div class="col-8 summary-value font-bold" id="credential-user">{{ createdCredentials.user }}</div>
        </div>
        <div class="row">
          <div class="col-4 summary-label">Contraseña:</div>
          <div class="col-8 summary-value font-bold" id="credential-password">{{ createdCredentials.password }}</div>
        </div>
      </div>
    </div>
  }
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-center gap-2">
      <p-button
        label="Copiar"
        icon="pi pi-copy"
        [rounded]="true"
        (onClick)="copyCredentials()"
        styleClass="p-button-outlined"
      />
      <p-button
        label="Cerrar"
        icon="pi pi-check"
        [rounded]="true"
        severity="success"
        (onClick)="closeCredentialsDialog()"
      />
    </div>
  </ng-template>
</p-dialog>
